export default "__VITE_ASSET__151ce99b__"